<div class="container" fxLayout="row wrap" fxLayoutAlign="space-between start">
  <div class="configuration-panel" fxLayout="column" fxFlex="100" [fxFlex.gt-sm]="collapsed ? 100 : 64">
    <button fxShow="true" fxShow.lt-md="false" class="collapse" mat-mini-fab (click)="toggleCollapse()" [matTooltip]="collapsed ? 'Expand' : 'Collapse'">
      <mat-icon *ngIf="collapsed">keyboard_double_arrow_left</mat-icon>
      <mat-icon *ngIf="!collapsed">keyboard_double_arrow_right</mat-icon>
    </button>
    <mat-card *ngIf="renderedOutput?.status === renderedOutputStatusEnum.InProgress" class="mat-card-inline-sm banner-info" fxFlex="100">
      <mat-card-content><span class="text-info">Rendering your situFACADE...</span></mat-card-content>
    </mat-card>
    <mat-card *ngIf="renderedOutput?.status === renderedOutputStatusEnum.Queued" class="mat-card-inline-sm banner-info" fxFlex="100">
      <mat-card-content *ngIf="renderedOutput?.queuePosition"><span class="text-info">Your situFACADE is positioned {{ renderedOutput.queuePosition }} in the queue for rendering...</span></mat-card-content>
      <mat-card-content *ngIf="!renderedOutput?.queuePosition"><span class="text-info">Your situFACADE is queued for rendering...</span></mat-card-content>
    </mat-card>
    <mat-card *ngIf="renderedOutput?.status === renderedOutputStatusEnum.Failed" class="mat-card-inline-sm banner-warning" fxFlex="100">
      <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
        <span class="text-warning">Your situFACADE failed, please try again...</span>
        <mat-icon class="link" matTooltip="Clear failure" (click)="clearFacade()">clear</mat-icon>
      </mat-card-content>
    </mat-card>
    <mat-card *ngIf="renderedOutput?.status === renderedOutputStatusEnum.Complete" class="mat-card-inline-sm">
      <mat-card-content class="mat-card-inline-sm" fxFlex="100" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
        <div class="w-100" fxFlex="100" fxLayout="row wrap" fxLayoutAlign="start center">
          <div fxFlex="100" fxLayout="row"
            fxLayoutAlign="start center" class="image-comparison-container">
            <img-comparison-slider value="75" class="image-slider">
              <figure slot="first" class="before">
                <img *ngIf="secondryFacade?.imageUrl" class="w-100 h-100" [src]="secondryFacade?.imageUrl">
                <img *ngIf="!secondryFacade?.imageUrl" class="w-100 h-100 blurred-image" [src]="renderedOutput?.imageUrl">
                <figcaption>Comparison</figcaption>
              </figure>
              <figure slot="second" class="after">
                <img class="w-100 h-100" [src]="renderedOutput?.imageUrl">
                <figcaption>Current</figcaption>
                <ng-container *ngIf="isReleasePermitted && hasReleaseItems">
                  <div class="debug-action-container">
                    <mat-icon class="link" color="primary" matTooltip="Report an issue" (click)="addEditReleaseIssue()" (mousedown)="$event?.stopPropagation()" (touchstart)="$event?.stopPropagation()" matTooltipPosition="below" aria-hidden="false" aria-label="shareLocation">
                      bug_report
                    </mat-icon>
                  </div>
                </ng-container>
              </figure>
              <svg slot="handle" xmlns="http://www.w3.org/2000/svg" width="100" viewBox="-8 -3 16 6" value="75">
                <path stroke="#fff" d="M -5 -2 L -7 0 L -5 2 M 5 -2 L 7 0 L 5 2" stroke-width="2" fill="none" vector-effect="non-scaling-stroke"></path>
              </svg>
            </img-comparison-slider>
            <div class="image-comparison-overlay" *ngIf="(!renderedOutput || renderedOutput.isProduction || renderedOutput.parentRenderedOutputId)">This is already live! (Comparison = Current)</div>
            <div class="image-comparison-overlay" *ngIf="!(!renderedOutput || renderedOutput.isProduction || renderedOutput.parentRenderedOutputId)">Not yet live</div>
            <div class="source-artifacts-overlay" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
              <div>
                <button color="accent" mat-mini-fab (click)="browse(renderedOutput?.styleConfigTemplate?.id, renderedOutput?.homeConfigId)" matTooltip="View situFACADE history">
                  <mat-icon class="link">history</mat-icon>
                </button>
                <button (click)="share(true)" color="accent" mat-icon-button matTooltip="Share situPORTAL">
                  <mat-icon class="link">content_copy</mat-icon>
                </button>
                <button (click)="share()" color="accent" mat-mini-fab matTooltip="Share situLINK">
                  <mat-icon class="link">share</mat-icon>
                </button>
                <button color="primary" mat-mini-fab (click)="setDefault()" matTooltip="Set your situFACADE default">
                  <mat-icon class="link">lock</mat-icon>
                </button>
                <button *ngIf="isSituUser || isAdmin" color="primary" mat-mini-fab (click)="setDefault(true)" matTooltip="Set global situFACADE default">
                  <mat-icon class="link">vpn_lock</mat-icon>
                </button>
              </div>
              <source-artifacts-menu colourOverride="info" [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode"  *ngIf="renderedOutput?.sourceArtifacts" [sourceArtifacts]="renderedOutput.sourceArtifacts"></source-artifacts-menu>
            </div>
            <div *ngIf="secondryFacade?.sourceArtifacts" class="source-artifacts-secondry-overlay">
              <source-artifacts-menu colourOverride="warning" [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode" [sourceArtifacts]="secondryFacade.sourceArtifacts"></source-artifacts-menu>
              <mat-icon class="link white-icon" (click)="secondryFacade = undefined" matTooltip="Clear comparison situFACADE">clear</mat-icon>
            </div>
          </div>

          <div *ngIf="renderedOutput" class="m-t-10" fxFlex="100" fxLayout="row">
            <div class="download-container" fxFlex="70" fxLayout="row wrap" fxLayoutAlign="start center">
              <mat-label fxHide.lt-lg>Download</mat-label>
              <button mat-icon-button [matTooltip]="renderedOutput?.res2kArtifactId ? 'download 2k' : 'view this at 2k'"
                [color]="renderedOutput?.res2kArtifactId ? 'accent' : 'primary'"
                (click)="renderedOutput?.res2kArtifactId ? download(renderedOutput.res2kArtifactId) : renderChild('2048x1536', renderedOutput?.res2kArtifactId)">
                <mat-icon class="option-icon">2k</mat-icon>
              </button>
              <mat-icon *ngIf="!renderedOutput?.parentRenderedOutputId">arrow_right</mat-icon>
              <mat-icon *ngIf="renderedOutput?.parentRenderedOutputId">arrow_left</mat-icon>
              <button mat-icon-button [matTooltip]="renderedOutput?.res4kArtifactId ? 'download 4k' : 'view this at 4k'"
                [color]="renderedOutput?.res4kArtifactId ? 'accent' : 'primary'"
                (click)="renderedOutput?.res4kArtifactId ? download(renderedOutput.res4kArtifactId) : renderChild('4096x3072', renderedOutput?.res4kArtifactId)">
                <mat-icon class="option-icon">4k</mat-icon>
              </button>
              <mat-icon *ngIf="!renderedOutput?.parentRenderedOutputId">arrow_right</mat-icon>
              <mat-icon *ngIf="renderedOutput?.parentRenderedOutputId">arrow_left</mat-icon>
              <button mat-icon-button [disabled]="!isSituUser" [matTooltip]="renderedOutput?.res8kArtifactId ? 'download 8k' : 'view this at 8k'"
                [color]="renderedOutput?.res8kArtifactId ? 'accent' : 'primary'"
                (click)="renderedOutput?.res8kArtifactId ? download(renderedOutput.res8kArtifactId) : renderChild('8192x6144', renderedOutput?.res8kArtifactId)">
                <mat-icon class="option-icon">8k</mat-icon>
              </button>
              <mat-icon *ngIf="!renderedOutput?.parentRenderedOutputId">arrow_right</mat-icon>
              <mat-icon *ngIf="renderedOutput?.parentRenderedOutputId">arrow_left</mat-icon>
              <button mat-icon-button [disabled]="!isSituUser" [matTooltip]="renderedOutput?.res16kArtifactId ? 'download 16k' : 'view this at 16k'"
                [color]="renderedOutput?.res16kArtifactId ? 'accent' : 'primary'"
                (click)="renderedOutput?.res16kArtifactId ? download(renderedOutput.res16kArtifactId) : renderChild('16384x12288', renderedOutput?.res16kArtifactId)">
                <mat-icon class="option-icon">8k_plus</mat-icon>
              </button>
            </div>

            <div fxFlex="30" fxLayout="row" fxLayoutAlign="end center">
              <button *ngIf="isReleasePermitted" color="accent" mat-flat-button aria-label="Send to Live" (click)="sendToLive()" [disabled]="!renderedOutput || renderedOutput.isProduction || renderedOutput.parentRenderedOutputId">
                <mat-icon>verified</mat-icon>
                <span fxHide.lt-lg>Send to Live</span>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    
    <mat-card class="mat-card-inline-sm" fxLayout="row" fxFlex="100">
      <mat-card-content fxFlex="100" fxLayout="column" fxLayoutAlign="start start">
        <div #homeConfiguration fxLayout="row" fxLayoutAlign="start center" class="m-b-20 text-warning" [class.text-success]="selectedHomeConfigId">
          Home Configuration
          <button [disabled]="!selectedHomeConfigId" color="primary" mat-icon-button matTooltip="browse similar home configurations" (click)="browse('', selectedHomeConfigId)">
            <mat-icon class="small-icon">search</mat-icon>
          </button>
        </div>
        <home-config-slim class="w-100"
          [incomingHomeConfigId]="renderedOutput?.homeConfigId"
          [lockedStaging]="true"
          [product]="facadeProductName"
          (homeIdUpdates)="onHomeIdUpdates($event)"
          (homeConfigUpdates)="onHomeConfigUpdates($event)"
          (homeConfigIdUpdates)="onHomeConfigIdUpdates($event)">
        </home-config-slim>
          
        <div #styleSelections fxLayout="row" fxLayoutAlign="start center" class="m-b-20 text-warning" [class.text-success]="selectedStyleTemplateId">
          Style Selections
          <button [disabled]="!selectedStyleTemplateId" color="primary" mat-icon-button matTooltip="browse similar style configurations" (click)="browse(selectedStyleTemplateId, '')">
            <mat-icon class="small-icon">search</mat-icon>
          </button>
        </div>
        <style-config class="w-100" [canEditTemplates]="isAdmin || isSituUser" [canAddTemplates]="isAdmin || isSituUser" 
          [incomingStyleConfigTemplateId]="renderedOutput?.styleConfigTemplate?.id"
          [incomingHomeId]="selectedHomeId"
          [backend]="false"
          [saveTemplate]="saveTemplateTrigger"
          [product]="facadeProductName"
          (onStyleTemplateChange)="onStyleTemplateIdUpdates($event)"
          (onSavePendingChange)="onSavePendingUpdates($event)">
        </style-config>

        <div class="w-100 m-t-10" fxLayout="row" fxLayoutAlign="end center">
          <div fxFlex="50" fxLayout="row" fxLayoutAlign="start center">
            <ul>
              <li [matTooltip]="selectedHomeConfigId ? 'Valid' : 'NOT valid'" (click)="scrollToHomeConfiguration()"><span class="link text-warning" [class.text-success]="selectedHomeConfigId">Home Configuration</span></li>
              <li [matTooltip]="selectedStyleTemplateId ? 'Valid' : 'NOT valid'" (click)="scrollToStyleSelections()"><span class="link text-warning" [class.text-success]="selectedStyleTemplateId">Style Selections</span></li>
              <li *ngIf="renderedOutput && renderedOutput?.status !== renderedOutputStatusEnum.Complete">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <span class="text-warning">Facade in progress</span>
                  <mat-icon class="link small-icon" matTooltip="Clear situFACADE in progress" (click)="clearFacade()">clear</mat-icon>
                </div>
              </li>
            </ul>
          </div>
          <div class="h-100" fxFlex="50" fxLayout="row" fxLayoutAlign="end end">
            <button *ngIf="styleTemplateSavePending" matTooltip="Save Render Config" color="primary" mat-flat-button aria-label="Save Config" (click)="saveTemplate();">
              Save
            </button>
            <button *ngIf="selectedHomeConfigId && selectedStyleTemplateId && isReleasePermitted"
              (click)="addToRelease('Single')" 
              color="accent" mat-icon-button matTooltip="Add configuration to release" aria-label="Add configuration to release">
              <mat-icon>add_box</mat-icon>
            </button>
            <button *ngIf="selectedHomeConfigId && selectedStyleTemplateId && isReleasePermitted" 
              (click)="addToRelease('MasterFiles')" 
              color="accent" mat-icon-button matTooltip="Add configuration with all master files to release" aria-label="Add configuration with all master files to release">
              <mat-icon>queue</mat-icon>
            </button>
            <button *ngIf="selectedHomeConfigId && selectedStyleTemplateId && isReleasePermitted" 
              (click)="addToRelease('Options')" 
              color="accent" mat-icon-button matTooltip="Add configuration with all selected options separately" aria-label="Add configuration with all selected options separately">
              <mat-icon>filter_none</mat-icon>
            </button>
            <button *ngIf="!styleTemplateSavePending" matTooltip="view this situFACADE configuration" color="primary" mat-flat-button
                [disabled]="!selectedHomeConfigId || !selectedStyleTemplateId ||
                renderedOutput?.status === renderedOutputStatusEnum.InProgress || renderedOutput?.status === renderedOutputStatusEnum.Queued || renderedOutput?.status === renderedOutputStatusEnum.Failed"
                (click)="render();" >
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2px">
                  <span>Create situFACADE</span><mat-icon>2k</mat-icon>
                </div>
            </button>
          </div>
        </div>  
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="renderedOutput?.status === renderedOutputStatusEnum.Complete" class="mat-card-inline-sm">
      <mat-card-content class="mat-card-inline-sm" fxFlex="100" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
        <div class="section-label text-success">Embed</div>
        <div *ngIf="!paramDisableEmbed" fxFlex="100" class="w-100" fxLayoutAlign="start center">
          <iframe title="Situ Facade" [src]="getLiveFacadeEmbedUrl(undefined, true) | safe" class="embed" [ngClass.lt-md]="'embed-small'" frameborder="0"></iframe>
        </div>
        <mat-accordion class="w-100 embed-headers-align">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Simple
              </mat-panel-title>
              <mat-panel-description> 
                Place this situFACADE on your web page with one line of html
              </mat-panel-description>
            </mat-expansion-panel-header>

            <pre class="language-markup"><code class="language-markup" style="white-space: initial;" [innerHtml]="renderedOutput?.prismEmbedCode"></code></pre>

            <div fxLayout="row" fxLayoutAlign="end center">
              <button color="accent" mat-flat-button (click)="copyToClipboard(renderedOutput?.embedCode)">Copy Embed</button>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                API for Devs
              </mat-panel-title>
              <mat-panel-description>
                Have more control with this API to place embeds dynamically
              </mat-panel-description>
            </mat-expansion-panel-header>

            <pre class="language-markup"><code class="language-markup" [innerHtml]="renderedOutput?.prismApiCode"></code></pre>
            <div fxLayout="row" fxLayoutAlign="end center">
              <button color="accent" mat-flat-button (click)="copyToClipboard(renderedOutput?.apiCode)">Copy API Embed</button>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-card-content>
    </mat-card>

    <home-config-list fxFlex="100" fxShow="false" fxShow.lt-md="true" [fxShow.gt-md]="collapsed" 
      [product]="facadeProductName"
      [viewRenderedOutput]="renderedOutput"
      [compareRenderedOutput]="secondryFacade"
      [refreshToken]="refreshToken"
      (selectedRenderedOutputId)="loadById($event);"
      (selectedComparisonRenderedOutputId)="loadComparisonById($event)"
      (onIssueSelectClick)="onIssueSelect($event)">
    </home-config-list>
  </div>

  <div class="favourites-panel" [fxShow]="!collapsed" fxShow.lt-md="false" fxFlex="35">
    <home-config-list [product]="facadeProductName"
      [viewRenderedOutput]="renderedOutput"
      [compareRenderedOutput]="secondryFacade"
      [refreshToken]="refreshToken"
      (selectedRenderedOutputId)="loadById($event);"
      (selectedComparisonRenderedOutputId)="loadComparisonById($event)"
      (onIssueSelectClick)="onIssueSelect($event)">
    </home-config-list>
  </div>
</div>